<template>
    <div class="campo-form">
        <div class="label-container">
            <label>{{ label }}<span style="color: #bb2a17" v-if="required">*</span></label>
            <slot name="acoes"></slot>
        </div>
        <InputMask
            class="input"
            mask="99/99/9999"
            :placeholder="placeholder"
            :name="name"
            v-model="inputValue"
            @update:modelValue="emit('update:modelValue', $event)"
        />
    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue';
import InputMask from 'primevue/inputmask';

const props = defineProps({
    label: String,
    placeholder: String,
    name: String,
    modelValue: String,
    required: Boolean,
});

const emit = defineEmits(['update:modelValue']);
const inputValue = ref(props.modelValue || '');
</script>

<style scoped lang="scss">
.campo-form {
    width: 100%;

    .input {
        width: 100%;
    }

    .label-container {
        padding-bottom: 4px;
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 700;
        color: #252529;
    }
}
</style>
